/**
 * The dark band's chrome shared by the kiosk's resting screens — the scan
 * screen and the chooser (D-019). Moved here verbatim from ScanScreen; styled
 * by ScanScreen.css, which both screens load.
 */

import { daysUntil } from "../api/kiosk";

/** Warn staff this far ahead of device-token expiry. */
const EXPIRY_WARN_DAYS = 7;

export function ConnectionPill({ online }: { online: boolean }) {
  return (
    <span className={`pill${online ? "" : " is-offline"}`} role="status">
      <span className="pill-dot" aria-hidden="true" />
      {online ? "Online" : "Offline"}
    </span>
  );
}

/** Gold strip under the topbar once the device token is within a week of lapsing. */
export function ExpiryBanner({ expiresAt }: { expiresAt: string | undefined }) {
  const expiryDays = daysUntil(expiresAt);
  if (expiryDays === null || expiryDays > EXPIRY_WARN_DAYS) return null;
  return (
    <div className="expiry-banner" role="status">
      <span aria-hidden="true">⚠</span>
      {expiryDays < 0
        ? "This device's registration has lapsed — re-register now"
        : `Re-register this device soon — ${expiryDays} day${expiryDays === 1 ? "" : "s"} left`}
    </div>
  );
}
